import { Switch } from "@headlessui/react";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router";

export function Header({ isOn, setIsOn }) {
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:justify-between md:items-center flex-wrap">
      <div className="flex flex-col gap-y-2 min-w-0 w-full md:w-auto">
        <h1 className="text-gray-900 dark:text-gray-100 font-bold text-xl md:text-2xl">
          Job Matches
        </h1>
        <p className="text-gray-700 dark:text-gray-300 text-sm md:text-base font-normal">
          Tailored matches based on your profile and preferences
        </p>
      </div>
      <div className="flex flex-col gap-y-2 w-full md:w-auto md:flex-row md:gap-x-6 md:items-center md:justify-center">
        <div className="flex md:flex-row md:items-center justify-between gap-x-2">
          <h1 className="text-gray-900 dark:text-gray-100 font-semibold text-sm md:text-base">
            Matching On
          </h1>
          <Switch
            checked={isOn}
            className="group inline-flex h-4 w-10 md:h-6 md:w-11 items-center rounded-full bg-gray-200 dark:bg-gray-700 transition data-checked:bg-blue-700"
            onChange={setIsOn}
          >
            <span className="size-3 md:size-4 translate-x-1 rounded-full bg-white transition group-data-checked:translate-x-6" />
          </Switch>
        </div>
        <button
          className="flex flex-row items-center justify-center gap-x-2 text-blue-700 dark:text-blue-400 text-sm md:text-base font-semibold hover:text-blue-600 dark:hover:text-blue-300 cursor-pointer mt-2 md:mt-0"
          type="button"
          onClick={() =>
            navigate("/setpreferences", { state: { from: "editpreferences" } })
          }
        >
          <span>
            <Pencil className="size-3" />
          </span>
          <span>Edit Preferences</span>
        </button>
      </div>
    </div>
  );
}
